import { type ReactNode } from 'react'
import { EmptyState, Button, Typography } from 'shared/ui'
import { DeveloperDocsSelect } from 'pages/settings/pages/developer/ui/DeveloperDocsSelect/DeveloperDocsSelect'
import styles from './styles.module.scss'

export type IDeveloperEmptyStateProps = {
  title: ReactNode
  text: string
  primaryButtonText: string
  onPrimaryClick: () => void
  ariaLabel: string
}

export const DeveloperEmptyState = ({
  title,
  text,
  primaryButtonText,
  onPrimaryClick,
  ariaLabel,
}: IDeveloperEmptyStateProps) => {
  return (
    <section className={styles.empty} aria-label={ariaLabel}>
      <EmptyState
        iconProps={{ icon: 'container', color: 'var(--content-brand-primary)', fontSize: 42 }}
        title={
          typeof title === 'string' ? (
            <Typography
              variant='heading-lg'
              ariaLabel={`${ariaLabel}Title`}
              className={styles.title}
              tag='div'
            >
              {title}
            </Typography>
          ) : (
            title
          )
        }
        text={text}
        typographyProps={{
          variant: 'body-lg-regular',
          marginBottom: '2px',
          color: 'var(--content-primary-tertiary)',
          ariaLabel: `${ariaLabel}Text`,
        }}
        boxProps={{
          gap: '32px',
          width: '360px',
          height: 'unset',
          textAlign: 'center',
        }}
        actions={
          <div className={styles.actions}>
            <Button
              text={primaryButtonText}
              size='medium'
              icon='add'
              onClick={onPrimaryClick}
              className={styles.actionButton}
            />
            <DeveloperDocsSelect className={styles.actionButton} />
          </div>
        }
      />
    </section>
  )
}
